module.exports = __webpack_public_path__ + "static/img/1_1_1.bdb6c5c0.jpg";